import React from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { WhyFailedSection } from './components/sections/WhyFailedSection';
import { MechanismSection } from './components/sections/MechanismSection';
import { DeliverablesSection } from './components/sections/DeliverablesSection';
import { AudienceSection } from './components/sections/AudienceSection';
import { HowItWorksSection } from './components/sections/HowItWorksSection';
import { ProofSection } from './components/sections/ProofSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { FAQSection } from './components/sections/FAQSection';
import { PricingSection } from './components/sections/PricingSection';
import { Footer } from './components/layout/Footer';
export function App() {
  return <div className="min-h-screen bg-beige-light selection:bg-gold/30 selection:text-taupe" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <WhyFailedSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <DeliverablesSection data-id="element-6" />
        <AudienceSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <ProofSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <PricingSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}